module.exports = __webpack_public_path__ + "img/home_4.61e3a53f.jpg";